export default {
  panzoom: {
    helpText: 'Useful shortcuts:\n'
      + 'Ctrl + mouse wheel - zoom in/out\n'
      + 'Ctrl + Left mouse click + drag - pan the area\n',
  },
};
